import { ShapeIcon } from "@flash-tecnologia/hros-web-ui-v2";
import styled from "styled-components";

export const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spacings.xs4};
  @media screen and (max-width: 380px) {
    padding: 20px;
  }
`;

export const RadioCard = styled.div<{ clickable?: boolean; checked?: boolean }>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  max-height: 140px;
  padding: ${({ theme }) => theme.spacings.xs2};
  gap: ${({ theme }) => theme.spacings.xs3};
  border-radius: 8px;
  border: 1px solid
    ${({ theme, checked }) =>
      checked ? theme.colors.secondary[50] : theme.colors.neutral[80]};
  align-items: center;
  ${({ clickable, theme }) =>
    clickable &&
    `
    cursor: pointer;
    &:hover { border-color: ${theme.colors.secondary[50]}; }
  `}
  @media screen and (max-width: 720px) {
    flex-direction: column;
    align-items: center;
    max-height: 300px;
    gap: 0px;
  }
`;

export const RadioCardRight = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const RadioCardLeft = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacings.xs3};
  align-items: center;
`;

export const RadioOptionText = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const ClickableShapeIcon = styled(ShapeIcon)`
  cursor: pointer;
  align-self: auto;
  flex-shrink: 0;
`;
